import React, { Component } from "react";
import WelcomeSection from "../HomepageSections/LandingSection";
import CommunitySection from "../HomepageSections/CommunitySection";
import MembersSection from "../HomepageSections/MembersSection";
import ContactSection from "../HomepageSections/ContactSection";
import HomepageHeader from "../Header/homepageHeader";
import Header from "../Header/header";
import ModalVideo from "react-modal-video";

class HomeOld extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      count: "",
      showYoutubeVideo: false,
      isOpen: true,
    };
  }

  componentDidMount() {
    const link = document.createElement("link");
    link.href = "assets/css/homepageTheme.css";
    link.id = "homepageCss";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }

  render() {
    return (
      <>
        <div className="preloader">
          <div className="preloader-bounce">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div id="video">
          <Header hideSubHeader={true} />
          {localStorage.setItem("count", this.state.count)}
          <link
            href="https://fonts.googleapis.com/css?family=Raleway:100,300,400,500,700,900"
            rel="stylesheet"
          />

          <HomepageHeader />

          <link
            href="https://fonts.googleapis.com/css?family=Raleway:100,300,400,500,700,900"
            rel="stylesheet"
          />
          <video
            autoPlay
            muted
            loop
            className="position-fixed"
            height="100%"
            width="100%"
          >
            <source src="assets/video/Background.m4v" type="video/mp4"></source>
          </video>
          <div id="fullpage">
            <WelcomeSection
              showVideo={(show) => this.setState({ showYoutubeVideo: show })}
            />
            <CommunitySection />
            <MembersSection />
            {/* <ComingSoonSection /> */}
            <ContactSection />
          </div>

          <div id="social-icons">
            <div className="text-right">
              <ul className="social-icons">
                <li>
                  <a
                    href="https://www.facebook.com/AI4Youth/"
                    title="AISC Facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/Ai4Youth?s=20"
                    title="AISC Twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.secure.instagram.com/ai4.youth/"
                    title="AISC Instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UC5GefdX-CUrWuMJ7iHGc2nw"
                    title="AISC Youtube"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-youtube"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <ModalVideo
            channel="youtube"
            autoplay="true"
            isOpen={this.state.showYoutubeVideo}
            width="930px"
            height="528px"
            videoId="az_FvqERn5s"
            onClose={() => this.setState({ showYoutubeVideo: false })}
          />
        </div>
      </>
    );
  }
}

export default HomeOld;
